/**
 * Add thousands separators for display without changing the numeric value we
 * submit. Designed for editable currency inputs, so partial decimals such as
 * "1000." remain editable instead of being rounded while the user types.
 */
export const formatMoneyInput = (value) => {
  if (value === null || value === undefined || value === '') return '';
  const raw = String(value).replace(/,/g, '');
  const match = raw.match(/^(-?)(\d*)(\.\d*)?$/);
  if (!match) return String(value);
  const [, sign, integer, decimal = ''] = match;
  const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `${sign}${grouped}${decimal}`;
};

export const unformatMoneyInput = (value) => String(value ?? '').replace(/,/g, '');

/**
 * Money formatting is field-driven, not template-driven. Legacy imports often
 * lost currency_format_money, so recognise Bullhorn's monetary rate mappings
 * as money even when that flag was persisted as false/defaulted to zero.
 */
export const isMoneyField = (field = {}) => {
  const fieldType = String(field.field_type ?? field.fieldType ?? '').toLowerCase();
  if (fieldType !== 'number') return false;

  const configured = field.currency_format_money ?? field.currencyFormatMoney;
  if (configured === true || configured === 1) return true;

  const mapped = String(
    field.mapped_bullhorn_field ?? field.mappedBullhornField ??
    field.bullhorn_source_field ?? field.bullhornSourceField ?? ''
  ).trim();
  const leaf = mapped.split('.').pop() || '';
  if (/^(?:payRate|clientBillRate)$/i.test(leaf) || /custom(?:Bill|Pay)Rate\d*$/i.test(leaf)) {
    return true;
  }

  const symbol = String(field.currency_symbol ?? field.currencySymbol ?? '').trim();
  return configured == null && Boolean(symbol);
};
